import { render } from "./TopTagTemplate.vue?vue&type=template&id=363fc5f5"
import script from "./TopTagTemplate.vue?vue&type=script&lang=js"
export * from "./TopTagTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script